import { assign, createMachine, fromPromise } from 'xstate';

import { getPayslipAgreementStatus } from '../actors/navigation.http';
import { setPayslipAgreementStatus } from './navigation.machine.actions';

export const config = {
	actors: {
		getPayslipAgreementStatus: fromPromise(getPayslipAgreementStatus)
	},
	actions: {
		setPayslipAgreementStatus: assign(setPayslipAgreementStatus)
	}
};

export type NavigationContext = {
	canSelectAgreement: boolean;
};

export const machine = {
	context: {
		canSelectAgreement: false
	} as NavigationContext,
	id: 'navigation_machine',
	initial: 'getting_payslip_agreement_from_server',
	states: {
		getting_payslip_agreement_from_server: {
			invoke: {
				id: 'getPayslipAgreementStatus',
				src: 'getPayslipAgreementStatus',
				onDone: {
					target: 'final',
					actions: 'setPayslipAgreementStatus'
				},
				onError: 'final'
			}
		},
		final: {
			type: 'final'
		}
	}
};

export const navigationMachine = createMachine(machine).provide(config);
